import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LOCALES, DEFAULT_LOCALE } from "../i18n/index.js";
import Icon from "./icons.jsx";

const LABELS = {
  en: "English",
  ro: "Română",
  es: "Español",
  fr: "Français",
  de: "Deutsch",
  it: "Italiano"
};
const FLAGS = { en: "🇬🇧", ro: "🇷🇴", es: "🇪🇸", fr: "🇫🇷", de: "🇩🇪", it: "🇮🇹" };

export default function LocaleSwitcher({ inverse = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { lang } = useParams();
  const { t, i18n } = useTranslation();
  const current = SUPPORTED_LOCALES.includes(lang) ? lang : DEFAULT_LOCALE;
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const choose = (code) => {
    setOpen(false);
    i18n.changeLanguage(code);
    const seg = location.pathname.split("/").filter(Boolean);
    if (SUPPORTED_LOCALES.includes(seg[0])) seg[0] = code;
    else seg.unshift(code);
    navigate("/" + seg.join("/") + (location.search || ""));
  };

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button onClick={() => setOpen(o => !o)} aria-label={t("localeSwitcher.ariaChange")} style={{
        all: "unset", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6,
        padding: "8px 12px", borderRadius: 999, fontSize: 13, fontWeight: 500,
        color: inverse ? "rgba(255,255,255,.82)" : "var(--ink-2)",
        border: "1px solid " + (inverse ? "rgba(255,255,255,.32)" : "var(--line-2)")
      }}>
        <Icon name="globe" size={14} />
        <span style={{ textTransform: "uppercase", letterSpacing: ".06em" }}>{current}</span>
        <Icon name="chevron-down" size={12} />
      </button>
      {open && (
        <div style={{
          position: "absolute", right: 0, top: "calc(100% + 6px)", zIndex: 100,
          background: "var(--bg)", border: "1px solid var(--line)", borderRadius: 8,
          minWidth: 180, padding: 6, boxShadow: "0 12px 28px -12px rgba(16,14,12,.18)"
        }}>
          {SUPPORTED_LOCALES.map((code) => (
            <button key={code} onClick={() => choose(code)} style={{
              all: "unset", cursor: "pointer", display: "flex", alignItems: "center", gap: 10,
              width: "100%", boxSizing: "border-box", padding: "10px 12px", borderRadius: 6,
              fontSize: 14, color: "var(--ink)",
              background: code === current ? "var(--bg-2)" : "transparent",
              fontWeight: code === current ? 600 : 500
            }}>
              <span style={{ fontSize: 16 }}>{FLAGS[code]}</span>
              <span>{LABELS[code]}</span>
              <span style={{ marginLeft: "auto", fontSize: 11, color: "var(--muted)", textTransform: "uppercase", letterSpacing: ".08em" }}>{code}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
